import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import ChatItemContainer from "./ChatItemContainer";
import CloseIcon from "@mui/icons-material/Close";

const ConversationList = ({
  groupedConversations,
  activeConversation,
  onSelectConversation,
  onDeleteConversation,
}) => {
  const [hoverItemId, setHoverItemId] = useState(null);

  return (
    <Stack spacing={2} px={2}>
      {groupedConversations.map((group, groupIdx) =>
        group.data.length === 0 ? null : (
          <Stack key={group.label} spacing={1}>
            <Typography
              variant="caption"
              fontWeight={600}
              fontSize={13}
              color="#555"
              mt={groupIdx === 0 ? 0 : 2}
            >
              {group.label}
            </Typography>

            {group.data.map((conversation, idx) => {
              const isSelected =
                conversation?.conversation_id ===
                activeConversation?.conversation_id;

              return (
                <ChatItemContainer
                  key={`${group.label}-${idx}`}
                  onClick={() => onSelectConversation(conversation)}
                  selected={isSelected}
                  onMouseEnter={() =>
                    setHoverItemId(conversation.conversation_id)
                  }
                  onMouseLeave={() => setHoverItemId(null)}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    flex={1}
                    height={34}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: isSelected ? 600 : 400,
                        color: isSelected ? "#000" : "#333",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        flex: 1,
                      }}
                    >
                      {conversation.conversation_name || "Untitled"}
                    </Typography>

                    {hoverItemId === conversation.conversation_id && (
                      <Tooltip title="Delete chat">
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteConversation(conversation);
                          }}
                          size="small"
                          sx={{
                            ml: 1,
                            p: "2px",
                            color: "#777",
                            "&:hover": {
                              color: "#000",
                            },
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Stack>
                </ChatItemContainer>
              );
            })}
          </Stack>
        )
      )}
    </Stack>
  );
};

export default ConversationList;
